import { Canvas, FabricObject } from 'fabric';

import { DrawData } from '../../draw.constants';
import {
  CUSTOM_CANVAS_PROPS,
  OBJECT_SOURCE_KEY,
  OBJECT_SOURCE_KEY_QUESTION,
} from '../draw-canvas.constants';
import { isArtboard } from './is-artboard';
import { isEmptyTextbox } from './is-empty-textbox';

export function getDataToSave({
  canvas,
  dimensions,
  isCreateMode,
}: {
  canvas: Canvas;
  dimensions: {
    width: number;
    height: number;
  };
  isCreateMode: boolean;
}): DrawData {
  const data = canvas.toObject(CUSTOM_CANVAS_PROPS);

  if (isCreateMode) {
    return {
      data: {
        objects: data.objects.filter(
          (f: FabricObject) => !isArtboard(f) && !isEmptyTextbox(f)
        ),
        version: data.version,
      },
      originalWidth: dimensions.width,
      originalHeight: dimensions.height,
    };
  } else {
    return {
      data: {
        objects: data.objects.filter(
          (f: FabricObject) =>
            !isArtboard(f) &&
            !isEmptyTextbox(f) &&
            !(
              OBJECT_SOURCE_KEY in f &&
              (f as any)[OBJECT_SOURCE_KEY] === OBJECT_SOURCE_KEY_QUESTION
            )
        ),
        version: data.version,
      },
      originalWidth: dimensions.width,
      originalHeight: dimensions.height,
    };
  }
}
